import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "影视资讯", to: "/category/news" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-800 text-primary-100 mt-14">
      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-3">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-lg" />
              </span>
              <span className="font-heading font-extrabold text-background-50 text-lg tracking-wide">
                欧美日韩
              </span>
            </div>
            <p className="text-sm text-primary-200 leading-relaxed max-w-md">
              专注日韩与欧美电影、电视剧的内容门户，汇聚最新影视资讯、剧集详情与分类推荐，为影视爱好者提供清晰、舒适的浏览体验。
            </p>
          </div>

          <div>
            <h3 className="text-background-50 font-semibold text-sm mb-3">
              快速导航
            </h3>
            <ul className="space-y-2">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-primary-200 hover:text-accent-400 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-background-50 font-semibold text-sm mb-3">
              内容范围
            </h3>
            <ul className="space-y-2 text-sm text-primary-200">
              <li>日韩影视</li>
              <li>欧美电影</li>
              <li>热门剧集</li>
              <li>影视资讯</li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300 text-center sm:text-left">
            © 2026 欧美日韩影视平台 · 本站内容为演示展示，仅供学习交流，不提供在线播放服务。
          </p>
          <div className="flex items-center gap-3 text-primary-300">
            <span className="inline-flex items-center gap-1 text-xs">
              <i className="ri-shield-check-line" />
              演示站点
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}